'use strict';

/**
 * Angular App
 *
 * @package     WordPress
 * @subpackage  Plugin Manager
 * @since       6.0.0
 * @author      Sujin 수진 Choi http://www.sujinc.com/donation
*/

angular.module('PluginManager', ['PluginManager', 'dndLists', 'ui.indeterminate']);